import React from 'react'
import ApiUrl from '../../../configTools/apiUrl'
import { Link } from 'react-router-dom'
import { useState } from 'react'
import ProfileButton from '../../forms/profileButton'

const User = ({Refresh,userDetail}) => {
    const [User,setUser] = useState(JSON.parse(localStorage.getItem("user-info")));
    const Stars = ({count,reviews}) => (
        <p>
            {
                Array.from({length: count}).map((_item, index) => {
                    return(
                        <b key={index} className='colored'>★</b>
                    )
                })
            }
            {
                Array.from({length: 5-count}).map((_item, index) => {
                    return(
                        <b key={index} className='empty'>☆</b>
                    )
                })
            }
            {
                "("+reviews+")"
            }
        </p>
    )
    const change_follow = ()=>{
        if(User){
            fetch(ApiUrl.API_URL_Follower, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer '+User.token
                },
                body: JSON.stringify({
                    followtoid : userDetail.id
                })
              })
              .then(res=>res.json())
              .then(data =>{
                Refresh();
            });
        }
    }
  return (
    <div className='product_user'>
      <div className='product_user_details'>
        <div className='product_user_image'>
            <label style={{cursor:"pointer"}}>
                <div style={{
                    width: "100%",
                    paddingTop: "80%",
                    borderRadius: "10px",
                    position: "relative",
                    backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+userDetail.image})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    marginBottom:"20px"
                    
                }}>
                </div>
            </label>
        </div>
        <div className='product_user_about' style={{width:"100%"}}>
          <Link to={'/user/'+userDetail.username}><h5>{userDetail.firstname} {userDetail.lastname}</h5></Link>
          <p>@{userDetail.username}</p>
          <div className='product_user_about_reviews'>
          <Stars count={userDetail.averagestars} reviews={userDetail.reviewcount}/>
          </div>
        </div>
        <div className='followbutton'>
            {User && User.username !== userDetail.username &&
                <ProfileButton Value={userDetail.followingthis? "Unfollow": "Follow"} Action={change_follow} style={{cursor:"pointer"}}/>
            }
            {!User &&
                <Link to={'/login'}>
                    <ProfileButton Value={"Follow"}/>
                </Link>
            }
        </div>
      </div>
    </div>
  )
}

export default User
